module.exports = "/365FarmNet/dist/plantProtectantCore.8500af30d459620177c9cd046813698a.html";